export const MAX_TAB_COUNT = 15

// ── 홈(랜딩) 탭 — 유일 원천(single source of truth) ─────────────────────────
// 진입 랜딩·홈 탭·리다이렉트 대상을 여기 한 곳에서만 정의한다.
// 변경 시 이 4개 상수만 바꾸면 stores·plugins·middleware·pages 전체에 반영된다.
export const HOME_TAB_ID     = '/biz/ksis/main'
export const HOME_TAB_PATH   = '/biz/ksis/main'
export const HOME_TAB_TITLE  = '메인'
export const HOME_TAB_MSGKEY = 'PAGE_KSIS_MAIN'
